export default __webpack_public_path__ + "static/media/thumbnail-anim-sprite-6-frames.c01c5584.png";